import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type AuthMode = 'TENANT' | 'TENANTS';

type AuthStore = {
  accessToken: string | null;
  mode: AuthMode;
  setSession: ({ accessToken, mode }: { accessToken: string | null; mode: AuthMode }) => void;
  logout: () => void;
};

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      accessToken: null,
      mode: 'TENANT',
      setSession: ({ accessToken, mode }) => {
        set({ accessToken, mode });
      },
      logout: () => {
        set({ accessToken: null, mode: 'TENANT' });
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
